// Generated by purs version 0.15.15
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_String_Regex from "../Data.String.Regex/index.js";
import * as Data_String_Regex_Flags from "../Data.String.Regex.Flags/index.js";
import * as Data_String_Regex_Unsafe from "../Data.String.Regex.Unsafe/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Halogen_Styled from "../Halogen.Styled/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
var fromHomogeneous = /* #__PURE__ */ Foreign_Object.fromHomogeneous();
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var toUnfoldable = /* #__PURE__ */ Foreign_Object.toUnfoldable(Data_Unfoldable.unfoldableArray);
var AnimStep = /* #__PURE__ */ (function () {
    function AnimStep(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    AnimStep.create = function (value0) {
        return function (value1) {
            return new AnimStep(value0, value1);
        };
    };
    return AnimStep;
})();
var RuleSet = /* #__PURE__ */ (function () {
    function RuleSet(value0) {
        this.value0 = value0;
    };
    RuleSet.create = function (value0) {
        return new RuleSet(value0);
    };
    return RuleSet;
})();
var MediaRule = /* #__PURE__ */ (function () {
    function MediaRule(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    MediaRule.create = function (value0) {
        return function (value1) {
            return new MediaRule(value0, value1);
        };
    };
    return MediaRule;
})();
var AtKeyframes = /* #__PURE__ */ (function () {
    function AtKeyframes(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    AtKeyframes.create = function (value0) {
        return function (value1) {
            return new AtKeyframes(value0, value1);
        };
    };
    return AtKeyframes;
})();
var Raw = /* #__PURE__ */ (function () {
    function Raw(value0) {
        this.value0 = value0;
    };
    Raw.create = function (value0) {
        return new Raw(value0);
    };
    return Raw;
})();
var Cat = /* #__PURE__ */ (function () {
    function Cat(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Cat.create = function (value0) {
        return function (value1) {
            return new Cat(value0, value1);
        };
    };
    return Cat;
})();
var Empty = /* #__PURE__ */ (function () {
    function Empty() {

    };
    Empty.value = new Empty();
    return Empty;
})();
var semigroupStyleSheet = /* #__PURE__ */ (function () {
    return {
        append: Cat.create
    };
})();
var monoidStyleSheet = /* #__PURE__ */ (function () {
    return {
        mempty: Empty.value,
        Semigroup0: function () {
            return semigroupStyleSheet;
        }
    };
})();
var fold = /* #__PURE__ */ Data_Foldable.fold(Data_Foldable.foldableArray)(monoidStyleSheet);
var uniqueIdent = "$unique";
var step = function () {
    return function (name) {
        return function (sheet) {
            return new AnimStep(name, fromHomogeneous(sheet));
        };
    };
};
var select = function () {
    return function (selector) {
        return function (sheet) {
            return new RuleSet({
                selector: "." + (uniqueIdent + selector),
                declarations: fromHomogeneous(sheet)
            });
        };
    };
};
var select1 = /* #__PURE__ */ select();
var select_ = function () {
    return function (sheet) {
        return select1("")(sheet);
    };
};
var select_1 = /* #__PURE__ */ select_();
var rawSheet = /* #__PURE__ */ (function () {
    return Raw.create;
})();
var camelToKebab = /* #__PURE__ */ Data_String_Regex["replace$prime"](/* #__PURE__ */ Data_String_Regex_Unsafe.unsafeRegex("([a-z])([A-Z])")(Data_String_Regex_Flags.global))(function (v) {
    return function (v1) {
        if (v1.length === 2 && (v1[0] instanceof Data_Maybe.Just && v1[1] instanceof Data_Maybe.Just)) {
            return v1[0].value0 + ("-" + Data_String_Common.toLower(v1[1].value0));
        };
        return Partial_Unsafe.unsafeCrashWith("camelToKebab: impossible");
    };
});
var printDecls = function (obj) {
    var printDecl = function (v) {
        return camelToKebab(v.value0) + (": " + (v.value1 + ";"));
    };
    return Data_String_Common.joinWith("")(map(printDecl)(toUnfoldable(obj)));
};
var inline = function () {
    return function (r) {
        return Halogen_Styled.inlineRaw(printDecls(fromHomogeneous(r)));
    };
};
var printAnimStep = function (v) {
    return v.value0 + ("{" + (printDecls(v.value1) + "}"));
};
var printStyleSheet = /* #__PURE__ */ (function () {
    var go = function (v) {
        if (v instanceof RuleSet) {
            return v.value0.selector + (" " + ("{" + (printDecls(v.value0.declarations) + "}")));
        };
        if (v instanceof MediaRule) {
            return v.value0 + ("{" + (go(v.value1) + "}"));
        };
        if (v instanceof AtKeyframes) {
            return "@keyframes " + (v.value0 + ("{" + (Data_String_Common.joinWith("\x0a")(map(printAnimStep)(v.value1)) + "}")));
        };
        if (v instanceof Raw) {
            return v.value0;
        };
        if (v instanceof Cat) {
            return go(v.value0) + ("\x0a" + go(v.value1));
        };
        if (v instanceof Empty) {
            return "";
        };
        throw new Error("Failed pattern match at Halogen.Styled.DSL (line 56, column 8 - line 62, column 16): " + [ v.constructor.name ]);
    };
    return function ($38) {
        return Halogen_Styled.SheetTemplate(go($38));
    };
})();
var scopedSheet = function (ss) {
    return Halogen_Styled.scopedSheetRaw(uniqueIdent)(printStyleSheet(ss));
};
var animation = function (steps) {
    return fold([ new AtKeyframes(uniqueIdent, steps), select_1({
        animationName: uniqueIdent
    }) ]);
};
export {
    animation,
    inline,
    rawSheet,
    scopedSheet,
    select,
    select_,
    step,
    monoidStyleSheet,
    semigroupStyleSheet
};
//# sourceMappingURL=index.js.map
